import React from 'react';
import { Box, Typography, useMediaQuery } from '@mui/material';
import { pxToRem, pxTovW, theme } from '@geneo2-web/shared-ui';

interface StaticTimerProps {
  time: number; // time in seconds
  label?: string;
}

export const StaticTimer = ({ time, label }: StaticTimerProps) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  // Format time as MM:SS
  const minutes = Math.floor(time / 60)
    .toString()
    .padStart(2, '0');

  const seconds = (time % 60).toString().padStart(2, '0');

  return (
    <Box
      sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          width: { xs: pxToRem(90), md: pxTovW(190), lg: pxTovW(164) },
          height: { xs: pxToRem(36), md: pxTovW(100), lg: pxTovW(66) },
          // border: '2px solid green',
          borderRadius: '8px',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
          background: '#FFFFFF',
        }}
      >
        <Typography
          variant={isMobile ? 'h5' : 'h3'}
          sx={{
            fontWeight: 'bold',
            color: '#000',
            textAlign: 'center',
            fontFamily: 'Lato',
          }}
        >
          {minutes}:{seconds}
        </Typography>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            gap: pxToRem(10),
            marginTop: { md: '4px' },
          }}
        >
          <Typography variant={isMobile ? 'subText' : 'smallText'}>
            mins
          </Typography>
          <Typography variant={isMobile ? 'subText' : 'smallText'}>
            sec
          </Typography>
        </Box>
      </Box>

      {!isMobile && label && (
        <Typography
          variant="subtitle2"
          sx={{
            fontWeight: 'bold',
            marginTop: '12px',
          }}
        >
          {label}
        </Typography>
      )}
    </Box>
  );
};
